import { getExceptionsTypes } from '../../helper';

export const getRateLabel = (form, providerService) => {
  /**
   * Все сервисы с этими типыми, пишем Rate per 1 (единичный товар)
   * 10 - Package
   * 14 - Custom Comments Package
   * 16 - SEO Package
   */
  const exceptionsRateType = getExceptionsTypes();
  const per1Text = 'Rate per 1';

  if (form?.mode === 0) {
    const { service_type } = form;
    if (exceptionsRateType.includes(service_type)) {
      return per1Text;
    }
  }

  if (providerService) {
    if (providerService.service_type) {
      const serviceType = Number(providerService.service_type);
      if (exceptionsRateType.includes(serviceType)) {
        return per1Text;
      }
    }
  }

  return 'Rate per 1000';
};

/**
 *
 * @param {object|null} provider
 * @param {object|null} service
 * @param {string|null} errorProvider
 * @param {boolean} isLoadingProvider
 * @returns {boolean|*}
 */
export const getSyncMode = (provider, service, errorProvider, isLoadingProvider) => {
  if (!service) {
    return false;
  }
  if (errorProvider || isLoadingProvider) {
    return false;
  }
  return true;
};

/**
 *
 * @param {object|null} provider
 * @returns {boolean|*}
 */
export const getSyncDisabled = (provider) => {
  if (provider?.hasOwnProperty('service_auto_rate')) {
    return !provider.service_auto_rate
  }
  return true;
};
export const formattedRateValue = (value) => value.replace(/[,,]/, '.')
